import { Link } from 'react-router-dom'
import { LanguageSwitcher } from '../components/i18n/LanguageSwitcher'
import { AddToHomeScreen } from '../components/pwa/AddToHomeScreen'
import { catalog } from '../data/catalog'
import { useI18n } from '../i18n'
import styles from './KataLibrary.module.css'

const KODOKAN_URL = 'https://kdkjudo.org/'
const FEEDBACK_EMAIL = 'developers@the-fortitudes.com'

export function KataLibrary() {
  const { t } = useI18n()
  const feedbackMailto = `mailto:${FEEDBACK_EMAIL}?subject=${encodeURIComponent(t('library.feedbackSubject'))}`

  return (
    <div className={styles.page}>
      <header className={styles.hero}>
        <div className={styles.heroAtmosphere} aria-hidden="true">
          <span className={styles.washA} />
          <span className={styles.washB} />
          <span className={styles.washC} />
          <span className={styles.silk} />
        </div>
        <div className={styles.heroInner}>
          <div className={styles.heroTop}>
            <p className={styles.eyebrow}>{t('library.eyebrow')}</p>
            <LanguageSwitcher />
          </div>
          <h1 className={styles.title}>{t('library.title')}</h1>
          <p className={styles.subtitle}>{t('library.subtitle')}</p>
        </div>
      </header>

      <div className={styles.body}>
        <ul className={styles.grid}>
          {catalog.map((kata) => (
            <li key={kata.id}>
              <Link
                to={`/kata/${kata.id}`}
                className={`${styles.card} ${styles[`theme-${kata.id}`] ?? ''}`}
                style={{
                  backgroundColor: kata.theme.from,
                  color: kata.theme.text,
                }}
              >
                <span className={styles.cardText}>
                  <span className={styles.cardName} lang="ja">
                    {kata.nameJa}
                  </span>
                  <span className={styles.cardRomaji}>{kata.name}</span>
                </span>
                <span className={styles.arrow} aria-hidden="true">
                  ↗
                </span>
              </Link>
            </li>
          ))}
        </ul>

        <footer className={styles.footer}>
          <a
            className={styles.kodokan}
            href={KODOKAN_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>{t('library.kodokan')}</span>
            <svg
              className={styles.externalIcon}
              viewBox="0 0 16 16"
              width="14"
              height="14"
              aria-hidden="true"
              focusable="false"
            >
              <path
                fill="currentColor"
                d="M9.25 2a.75.75 0 0 0 0 1.5h2.19L6.22 8.72a.75.75 0 1 0 1.06 1.06L12.5 4.56v2.19a.75.75 0 0 0 1.5 0V2.75A.75.75 0 0 0 13.25 2H9.25Z"
              />
              <path
                fill="currentColor"
                d="M3.5 4.25c0-.69.56-1.25 1.25-1.25H7A.75.75 0 0 0 7 1.5H4.75A2.75 2.75 0 0 0 2 4.25v7A2.75 2.75 0 0 0 4.75 14h7A2.75 2.75 0 0 0 14.5 11.25V9a.75.75 0 0 0-1.5 0v2.25c0 .69-.56 1.25-1.25 1.25h-7c-.69 0-1.25-.56-1.25-1.25v-7Z"
              />
            </svg>
            <span className="sr-only">{t('common.opensNewTab')}</span>
          </a>

          <div className={styles.footerGrid}>
            <p className={styles.dataLink}>
              <Link to="/manual">{t('library.manualLink')}</Link>
            </p>

            <p className={styles.dataLink}>
              <Link to="/data">{t('library.dataLink')}</Link>
            </p>

            <AddToHomeScreen className={`${styles.footerCell} ${styles.footerSpan}`} />

            <section className={styles.footerPanel} aria-labelledby="waitlist-heading">
              <h2 id="waitlist-heading" className={styles.footerPanelTitle}>
                {t('library.waitlistTitle')}
              </h2>
              <p className={styles.footerPanelBody}>{t('library.waitlistBody')}</p>
              <Link className={styles.footerPanelLink} to="/cloud-sync">
                {t('library.waitlistLearnMore')}
              </Link>
            </section>

            <section className={styles.footerPanel} aria-labelledby="feedback-heading">
              <h2 id="feedback-heading" className={styles.footerPanelTitle}>
                {t('library.feedbackTitle')}
              </h2>
              <p className={styles.footerPanelBody}>{t('library.feedbackBody')}</p>
              <a className={styles.footerPanelLink} href={feedbackMailto}>
                {t('library.feedbackCta')}
                <span className={styles.footerPanelEmail}>{FEEDBACK_EMAIL}</span>
              </a>
            </section>

            <p className={`${styles.disclaimer} ${styles.footerSpan}`}>
              {t('library.disclaimer')}
            </p>
          </div>
        </footer>
      </div>
    </div>
  )
}
